import React, { useEffect, useState } from "react";
import CardPage from "../../layout/CardPage";
import { Button, Space } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startGetClientes } from "../../context/actions/clientesActions";
import { startGetProveedores } from "../../context/actions/proveedoresActions";
import { startGetEstadosTodos } from "../../context/actions/reportesActions";
import { ModalReasignacionesXls } from "./ModalReasignacionesXls";
import { ModalCostosXls } from "./ModalCostosXls";
import { ModalSeguimientosXls } from "./ModalSeguimientosXls";

export const Reportes = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [openModalReasignacion, setOpenModalReasignacion] = useState(false);
  const [openModalCostos, setOpenModalCostos] = useState(false);
  const [openModalSeguimientos, setOpenModalSeguimientos] = useState(false);

  useEffect(() => {
    dispatch(startGetClientes());
    dispatch(startGetProveedores());
    dispatch(startGetEstadosTodos());
  }, [dispatch]);

  return (
    <CardPage titulo="Reportes">
      <Space wrap>
        <Button onClick={() => history.push("/reportes/dia")} type="primary">
          Reporte Asistencias por Día
        </Button>
        <Button
          onClick={() => history.push("/reportes/General")}
          type="primary"
        >
          Reporte General
        </Button>
        <Button
          onClick={() => history.push("/reportes/pagosProveedor")}
          type="primary"
        >
          Pagos a Proveedor
        </Button>
        <Button
          onClick={() => history.push("/reportes/reportesPorMes")}
          type="primary"
        >
          Reportes x Mes
        </Button>
        <Button
          onClick={() => history.push("/reportes/pagosPorPrograma")}
          type="primary"
        >
          Pagos por Programa
        </Button>
        <Button
          onClick={() => history.push("/reportes/reporteXls")}
          type="primary"
        >
          Xls
        </Button>
        <Button
          onClick={() => setOpenModalReasignacion(true)}
          type="primary"
        >
          Historial de Reasignación
        </Button>
        <Button
          onClick={() => setOpenModalCostos(true)}
          type="primary"
        >
          XLS Costos
        </Button>
        <Button
          onClick={() => setOpenModalSeguimientos(true)}
          type="primary"
        >
          Seguimientos XLS
        </Button>
        <Button onClick={() => history.push("/complementos")} type="primary">
          Complementos de Pago
        </Button>
      </Space>

      <ModalReasignacionesXls
        visible={openModalReasignacion}
        onClose={() => setOpenModalReasignacion(false)}
      />
      <ModalCostosXls
        visible={openModalCostos}
        onClose={() => setOpenModalCostos(false)}
      />
      <ModalSeguimientosXls
        visible={openModalSeguimientos}
        onClose={() => setOpenModalSeguimientos(false)}
      />
    </CardPage>
  );
};
